import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Wisconsin = () => {
  return (
    <StatePropertyTaxPage
      stateName="Wisconsin"
      processDescription="Property owners may appeal their assessment by filing with the local board of review during the board's session, typically in May. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="May"
      noticeOfValueMailedDateExplanation="Assessment notices are typically available in May when the assessment roll is open for examination."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Wisconsin assesses property as of January 1 each year. This assessment date captures the property's fair market value at the beginning of each calendar year for consistent statewide valuations."
      deadlineExplanation="Property owners must file appeals with the local board of review during the board's annual session, which typically occurs for a few days in May. The exact dates are set by each municipality."
    />
  );
};

export default Wisconsin;